import { Badge } from 'react-bootstrap';
import { Variant } from 'react-bootstrap/esm/types';

import { OrderStatusEnum } from 'src/models/GalenData/Order.model';

const OrderStatusBadge = (status: OrderStatusEnum) => {
  const statusConfig: Record<
    OrderStatusEnum,
    { color: Variant; label: string }
  > = {
    [OrderStatusEnum.OPEN]: { color: 'success', label: status },
    [OrderStatusEnum.PENDING]: { color: 'info', label: status },
    [OrderStatusEnum.COMPLETE]: { color: 'primary', label: status },
    [OrderStatusEnum.CLOSED]: { color: 'warning', label: status },
    [OrderStatusEnum.EXPIRED]: { color: 'danger', label: status },
    // TODO: change review and cancelled statuses from the default color to the required color
    [OrderStatusEnum.REVIEW]: { color: 'secondary', label: status },
    [OrderStatusEnum.CANCELLED]: { color: 'secondary', label: status },
  };

  const { color, label } = statusConfig[status];

  return (
    <Badge pill bg={color}>
      {label}
    </Badge>
  );
};

export default OrderStatusBadge;
